import React, {useState} from 'react';
import {useDispatch} from 'react-redux';

// styles
import * as S from './Spotlight.styles';

// types
import {ISpotlightInfo} from '@stencil/hotels-types/src/common/types';

// utils
import {isObjectEmpty} from '@stencil/hotels-utils/src/common-utils';

// analytics
import {omnitureThunk, omnitureConfig} from '@stencil/omniture-analytics/src';
import {SRPPageComponents} from '@stencil/omniture-analytics/src/constants/srp';

// Define the type for spotlightInfo
interface SpotlightProps {
  isMobileWeb?: boolean;
  spotlightApplicable?: boolean;
  spotlightInfo?: ISpotlightInfo;
  setIsVisible?: (args: boolean) => void;
}

const Spotlight: React.FC<SpotlightProps> = ({
  isMobileWeb = false,
  spotlightApplicable = false,
  spotlightInfo = {} as ISpotlightInfo,
  setIsVisible = () => {},
}) => {
  const dispatch = useDispatch();
  const [showTooltip, setShowTooltip] = useState(false);

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsVisible(true);
    dispatch(
      omnitureThunk(omnitureConfig.pages.SrpUnif, omnitureConfig.events.ctaClick, {
        cta: {
          name: `${SRPPageComponents.spotlightIconClicked}`,
          type: omnitureConfig.ctaType.Card,
          componentName: SRPPageComponents.spotlightIconClicked,
        },
      }),
    );
  };

  // If spotlight is not applicable or spotlightInfo is empty, return null
  if (!spotlightApplicable || isObjectEmpty(spotlightInfo)) return null;

  const {iconUrl, title, desc} = spotlightInfo;

  return (
    <S.Container>
      <div
        onClick={handleClick}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
      >
        <S.ImageIcon src={iconUrl} alt={title} />
      </div>
      {!isMobileWeb && showTooltip && desc && <S.TooltipCard>{desc}</S.TooltipCard>}
    </S.Container>
  );
};

export default Spotlight;
